import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    props: {
        data : {
            type: Object,
            required: true
        },
        options : {
            type: Object,
            required: true    
        }
    },
    mounted() {
        this.renderChart(this.data, this.options)
        this.$emit("changeData");
    },
    watch: {
        /**
         * Update chart when data is modify
         *
         * @param {*} data 
         */
        data: function (data) {
            this.$data._chart.data = data;
            this.$data._chart.update();
            this.$emit("changeData");
        }
    },
}